<template>

  <div style="margin-left: 10px;margin-top: 5px">
    <viewer :images="[image]">
      <img v-for="(src,index) in [image]" :src="src" :key="index" style="height: 100px;margin-right: 5px">
    </viewer>
    <div style="text-align: center">{{name}}</div>
  </div>
</template>

<script>
  export default {
    name: "Label",
    props: ["name", "image", "flex"]
  }
</script>

<style lang="scss" scoped>
  .flex {
    display: flex;
  }

  .label {

    list-style: none;
    float: left;
    margin-right: 100px;
    font-size: 14px;
    color: #8d8b8b;
    width: 100%;
    line-height: 30px;



    .value {
      padding-left: 10px;
      color: #000000;
      opacity: 0.85;
    }
  }
</style>
